/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxGetPricing } from "../../funcs/sandboxGetPricing.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$sandboxGetPricing: ToolDefinition = {
  name: "sandbox-get-pricing",
  description: `Get Sandbox Pricing

Current sandbox pricing rate card, keyed by SKU (\`standard\`, \`browser\`, \`eval-python\`). Metered sandbox usage is billed \`hours × (per_hour + reserved_memory_GiB × per_gib_hour)\`; SKUs without a configured rate accrue no spend. Cluster admins only.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await sandboxGetPricing(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
